import NavigationBuilder from '../../components/NavigationBuilder/NavigationBuilder'

export default function AppearanceNavigationPage() {
  return <NavigationBuilder />
}
